export class ChronosJobListColumnDef{
    public values?: any[];
    constructor(
        public field: string,
        public title: string,
        public hidden: boolean = false,
        public width: number = 120,
        public attributes:Object = {},
        public format:string = "",
        
        public headerAttributes: Object = {}
        ){}
}

export class ChronosReportListColumnDef{
    public values?: any[];
    constructor(
        public field: string,
        public title: string,
        public hidden: boolean = false,
        public template: string,
        public width: number = 120,
        public attributes:Object = {},
        public format:string = "",
        
        public headerAttributes: Object = {}
        ){}
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-list/job-list-columns.ts